import { Badge, Group, MantineSize } from '@mantine/core'
import { IconAlertCircle } from '@tabler/icons-react'
import { FormattedMessage } from 'react-intl'

import { Tag } from '@/types/event'
import { formatTagName } from '../helpers/formatTagName'

type Props = {
  tags: Tag[]
  maxTags?: number
  badgeSize?: MantineSize
}

export const EventTagList = ({ tags, maxTags, badgeSize }: Props) => {
  // vp_agent_alert tags are shown first and highlighted in red
  const sorted = [...tags].sort((a, b) =>
    a.tag_source === 'vp_agent_alert'
      ? -1
      : b.tag_source === 'vp_agent_alert'
        ? 1
        : 0
  )

  const visible = maxTags !== undefined ? sorted.slice(0, maxTags) : sorted
  const hiddenCount = sorted.length - visible.length

  return (
    <Group gap="xs">
      {visible.map((tag) => (
        <Badge
          key={tag.tag_name}
          size={badgeSize}
          color={tag.tag_source === 'vp_agent_alert' ? 'red' : undefined}
          leftSection={
            tag.tag_source === 'vp_agent_alert' ? (
              <IconAlertCircle size={12} />
            ) : undefined
          }
        >
          {formatTagName(tag.tag_name)}
        </Badge>
      ))}
      {hiddenCount > 0 && (
        <Badge size={badgeSize} variant="outline">
          <FormattedMessage
            id="general.plusMore"
            values={{ count: hiddenCount }}
          />
        </Badge>
      )}
    </Group>
  )
}
